module.exports = __webpack_public_path__ + "static/sportsconnectadminlanding-7d66e7e4acc311018e23bef2833f85b4.png";